import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { AuthProvider } from "./providers/auth-provider";

// Importing the Bootstrap CSS
//import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import 'font-awesome/css/font-awesome.min.css';

ReactDOM.render(
    <AuthProvider>
    <App />
  </AuthProvider>,
    document.getElementById('root'));